/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HealthResult } from '../models/HealthResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DefaultService {
  /**
   * @returns HealthResult live 200 response
   * @throws ApiError
   */
  public static live(): CancelablePromise<Array<HealthResult>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/health/live',
    });
  }

  /**
   * @param verbose
   * @returns HealthResult ready 200 response
   * @throws ApiError
   */
  public static ready(verbose?: boolean | null): CancelablePromise<Array<HealthResult>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/health/ready',
      query: {
        verbose: verbose,
      },
    });
  }
}
